import addOutline from '../../node_modules/ionicons/dist/svg/add-outline.svg?raw';
import arrowBackOutline from '../../node_modules/ionicons/dist/svg/arrow-back-outline.svg?raw';
import arrowUndoOutline from '../../node_modules/ionicons/dist/svg/arrow-undo-outline.svg?raw';
import brushOutline from '../../node_modules/ionicons/dist/svg/brush-outline.svg?raw';
import bug from '../../node_modules/ionicons/dist/svg/bug.svg?raw';
import bugOutline from '../../node_modules/ionicons/dist/svg/bug-outline.svg?raw';
import bulb from '../../node_modules/ionicons/dist/svg/bulb.svg?raw';
import calendarOutline from '../../node_modules/ionicons/dist/svg/calendar-outline.svg?raw';
import cameraOutline from '../../node_modules/ionicons/dist/svg/camera-outline.svg?raw';
import chatbubbleOutline from '../../node_modules/ionicons/dist/svg/chatbubble-outline.svg?raw';
import checkmarkCircleOutline from '../../node_modules/ionicons/dist/svg/checkmark-circle-outline.svg?raw';
import checkmarkOutline from '../../node_modules/ionicons/dist/svg/checkmark-outline.svg?raw';
import chevronDownOutline from '../../node_modules/ionicons/dist/svg/chevron-down-outline.svg?raw';
import chevronUpOutline from '../../node_modules/ionicons/dist/svg/chevron-up-outline.svg?raw';
import closeCircleOutline from '../../node_modules/ionicons/dist/svg/close-circle-outline.svg?raw';
import closeOutline from '../../node_modules/ionicons/dist/svg/close-outline.svg?raw';
import cloudOfflineOutline from '../../node_modules/ionicons/dist/svg/cloud-offline-outline.svg?raw';
import constructOutline from '../../node_modules/ionicons/dist/svg/construct-outline.svg?raw';
import contrastOutline from '../../node_modules/ionicons/dist/svg/contrast-outline.svg?raw';
import ellipseOutline from '../../node_modules/ionicons/dist/svg/ellipse-outline.svg?raw';
import exitOutline from '../../node_modules/ionicons/dist/svg/exit-outline.svg?raw';
import flaskOutline from '../../node_modules/ionicons/dist/svg/flask-outline.svg?raw';
import folderOutline from '../../node_modules/ionicons/dist/svg/folder-outline.svg?raw';
import gridOutline from '../../node_modules/ionicons/dist/svg/grid-outline.svg?raw';
import hourglassOutline from '../../node_modules/ionicons/dist/svg/hourglass-outline.svg?raw';
import imageOutline from '../../node_modules/ionicons/dist/svg/image-outline.svg?raw';
import informationCircleOutline from '../../node_modules/ionicons/dist/svg/information-circle-outline.svg?raw';
import keyOutline from '../../node_modules/ionicons/dist/svg/key-outline.svg?raw';
import linkOutline from '../../node_modules/ionicons/dist/svg/link-outline.svg?raw';
import listOutline from '../../node_modules/ionicons/dist/svg/list-outline.svg?raw';
import lockClosedOutline from '../../node_modules/ionicons/dist/svg/lock-closed-outline.svg?raw';
import mailOutline from '../../node_modules/ionicons/dist/svg/mail-outline.svg?raw';
import mergeOutline from '../../node_modules/ionicons/dist/svg/git-merge-outline.svg?raw';
import openOutline from '../../node_modules/ionicons/dist/svg/open-outline.svg?raw';
import personCircleOutline from '../../node_modules/ionicons/dist/svg/person-circle-outline.svg?raw';
import scanOutline from '../../node_modules/ionicons/dist/svg/scan-outline.svg?raw';
import swapVerticalOutline from '../../node_modules/ionicons/dist/svg/swap-vertical-outline.svg?raw';
import timeOutline from '../../node_modules/ionicons/dist/svg/time-outline.svg?raw';
import trashOutline from '../../node_modules/ionicons/dist/svg/trash-outline.svg?raw';
import tvOutline from '../../node_modules/ionicons/dist/svg/tv-outline.svg?raw';
import volumeMediumOutline from '../../node_modules/ionicons/dist/svg/volume-medium-outline.svg?raw';
import warningOutline from '../../node_modules/ionicons/dist/svg/warning-outline.svg?raw';

/**
 * Ionicons as inline SVG. «Emoji brukes aldri i implementasjonen» (emoji are never used
 * in the implementation, brand-ui-guidelines): an emoji is drawn differently per operating
 * system, in fixed colours that do not follow the tenant's palette, and 🐞 is read aloud as
 * «marihøne» (ladybird). The names are the same as in `submissionStatus`/`knownIssueStatus`
 * in `theme/theme.ts` and in the icon map in `design/wireframes/innsending-web.jsx`.
 *
 * Same pattern as `panel/src/status/Ikon.tsx`. The paths go via `node_modules`
 * because the package's `exports` does not expose the SVG files; `?raw` inlines them at
 * build time, so `@innspel/web` gets no runtime dependency on ionicons.
 */
/** Ionicons puts a <title> in every SVG; it would read «Bug» aloud before the text. The icon is decorative. */
const utenTittel = (svg: string) => svg.replace(/<title>[\s\S]*?<\/title>/g, '');

const IKONER: Record<string, string> = Object.fromEntries(
  Object.entries({
    'arrow-back-outline': arrowBackOutline,
    'arrow-undo-outline': arrowUndoOutline,
    'brush-outline': brushOutline,
    // Fylte varianter: bare på sporvalgets to kort (DD-63), der ikonet bærer stemningen.
    'add-outline': addOutline,
    bug,
    bulb,
    'bug-outline': bugOutline,
    'calendar-outline': calendarOutline,
    'camera-outline': cameraOutline,
    'chatbubble-outline': chatbubbleOutline,
    'checkmark-circle-outline': checkmarkCircleOutline,
  /* Sporingslinjens passerte ledd (R7.3). */
  'checkmark-outline': checkmarkOutline,
    'chevron-down-outline': chevronDownOutline,
    'chevron-up-outline': chevronUpOutline,
    'close-circle-outline': closeCircleOutline,
    'close-outline': closeOutline,
    'cloud-offline-outline': cloudOfflineOutline,
    'construct-outline': constructOutline,
    'contrast-outline': contrastOutline,
    'ellipse-outline': ellipseOutline,
    'exit-outline': exitOutline,
    'flask-outline': flaskOutline,
    'folder-outline': folderOutline,
    'git-merge-outline': mergeOutline,
    'grid-outline': gridOutline,
    'hourglass-outline': hourglassOutline,
    'image-outline': imageOutline,
    'information-circle-outline': informationCircleOutline,
  'key-outline': keyOutline,
    'link-outline': linkOutline,
    'list-outline': listOutline,
    'lock-closed-outline': lockClosedOutline,
    'mail-outline': mailOutline,
    'open-outline': openOutline,
    'person-circle-outline': personCircleOutline,
    'scan-outline': scanOutline,
    'swap-vertical-outline': swapVerticalOutline,
    'time-outline': timeOutline,
    'trash-outline': trashOutline,
    'tv-outline': tvOutline,
    // H3.1: «Hva vi fant ut» — notisen til dem som meldte fra (konseptsidens `i-notis`).
    'volume-medium-outline': volumeMediumOutline,
    'warning-outline': warningOutline,
  }).map(([navn, svg]) => [navn, utenTittel(svg)]),
);

/** The names `Ikon` knows. A name not listed here throws at render time, never silently. */
export const IKONNAVN: readonly string[] = Object.keys(IKONER);

/**
 * Decorative icon — always next to text, never alone. Colour and shape do not carry
 * meaning on their own (DD-08), so the icon is `aria-hidden` and the text says everything.
 */
export function Ikon({ navn }: { navn: string }) {
  const svg = IKONER[navn];
  if (!svg) throw new Error(`[innspel] The icon «${navn}» is not included in Ikon.tsx.`);
  return <span aria-hidden="true" className="innspel-ikon" dangerouslySetInnerHTML={{ __html: svg }} />;
}
